import komtim from '../komtim'
import partner from './partner'
import management from './management'
import kompack from './kompack'
import komship from './komship'
import notification from './notification'
import affiliate from './affiliate'
import withdrawal from './withdrawal'
import komclass from './komclass'
import pumkm from './pumkm'
import komcards from './komcards'
import adminManagement from './adminManagement'
import komchat from './komchat'
import openApi from './open-api'
import komlabs from './komlabs'
// Komads
import komads from './komads'

// Komform
import komform from '../komform'

// Array of sections
export default [
  ...notification,
  ...withdrawal,
  ...komtim,
  ...komlabs,
  ...komship,
  ...kompack,
  ...komclass,
  ...komcards,
  ...komads,
  ...affiliate,
  ...pumkm,
  ...komform,
  ...komchat,
  ...openApi,
  ...management,
  ...partner,
  ...adminManagement,
]
